import File from './File';
import styles from './styles.css';

export {
    File,
    styles
}